<template>
  <div id="container" class="col-12">
    <div id="TituloDetalleDeDocumento_div">
      <h2 class="label-black" style="margin-bottom: 0px;">Organigrama</h2>
    </div>
    <div class="row d-flex">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 padding-div-low" style="margin-top:0px;margin-bottom:0px;">
        <div class="area custom-area">
          <p class="label-black">Filtros</p>
          <div class="row">
            <div class="form-group col-4">
              <C001Area
                :prefijo="enumeraciones.etiquetasDeHTML.Select"
                :tipo="enumeraciones.tiposDeSelect.Todas"
                v-on:valorParaElPadre="cambioAreaHistorialLaboral"
                :parametros="{}"
                :valorDefinido="this.datosLocales[0].valor.Id"
                :key="this.datosLocales[0].valor.Id"
              ></C001Area>
            </div>
            <div class="form-group col-4">
              <C039TiposDepartamento
                :prefijo="enumeraciones.etiquetasDeHTML.Select"
                :tipo="enumeraciones.tiposDeSelect.Seleccione"          
                v-on:valorParaElPadre="cambioTipoDepartamentoLaboral"
                :valorDefinido="this.datosLocales[1].valor.Id"          
                :hereda="this.datosLocales[0].valor.Id"
                :key="this.datosLocales[0].valor.Id"
              ></C039TiposDepartamento>
            </div>
            <div class="form-group col-2">
              <button v-on:click="buscarEstructuraOrganica" class="btn btn-custom btn-sm" >
                &nbsp; &nbsp; &nbsp;Buscar &nbsp; &nbsp; &nbsp;
              </button>        
            </div>
            <div class="form-group col-2">
              <button v-on:click="limpiarBusqueda" class="btn btn-secondary btn-sm">
                Limpiar búsqueda
              </button>        
            </div>
          </div>
          <div v-if="dataDelOrganigrama != null">
            <COrganigrama :dataDelOrganigrama="this.dataDelOrganigrama"></COrganigrama>
          </div>
        </div>
      </div>
    </div>    
  </div>
</template>
<script>
import catalogos from "@/../static/js/catalogos";
import enumeraciones from "@/../static/js/enumeraciones";
import comun from "@/../static/js/comun";
import api from "@/../static/js/api";

import axios from "axios";

export default {
  components: {
    C001Area: catalogos.PJ.C001Area,
    C039TiposDepartamento: catalogos.PJ.C039TipoDepartamento,
    'COrganigrama': () => import('./COrganigrama.vue')
  },
  data() {
    return {
      enumeraciones,
      
      dataDelOrganigrama: null,
      // employees: service.getEmployees(),
      employees: this.dataDelOrganigrama,
      dataSource: null,
      currentEmployee: {},
      popupVisible: false,
      datosLocales: [
        {
          Id: 0,
          key: "Area_TabLaborales",
          valor: {
            Id: 0,
            nombre: null
          }
        },
        {
          Id: 1,
          key: "Departamento_TabLaborales",
          valor: {
            Id: -1,
            nombre: null
          }
        }
      ]
    };
  },
  methods: {
    limpiarBusqueda(){
      this.dataDelOrganigrama = null;
      //this.datosLocales[0].valor.Id = 0;
      //this.datosLocales[1].valor.Id = -1;
    },
    buscarEstructuraOrganica() {
      comun.SeEstaCargandoInformacion(true);
      this.limpiarBusqueda();
      let areaId = this.datosLocales[0].valor.Id;      
      let departamentoIdAux = (this.datosLocales[1].valor.Id != -1) ? this.datosLocales[1].valor.Id : null;
      let peticion =  {
        "AreaId":areaId,
        "DepartamentoId":departamentoIdAux
      };      

      axios
        .post(
          api.conexion + api.SIAP.funcion.GetOrganigrama2,
          peticion,
          comun.CrearElHeaderDeAutorizacion(
            this.$store.state.Login_AutorizacionOriginal
          )
        )
        .then(response => {
          comun.SeEstaCargandoInformacion(false);
          console.log(response);
          if (response.data.SiHayError == false) {
            comun.mensajeDeAlerta(response.data.Satisfactorio, null, null);
            console.log(response.data);
            this.dataDelOrganigrama = response.data.Organigrama;  
          } else {
            comun.SeEstaCargandoInformacion(false);
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
        })
        .catch(e => {
          console.error(e);
          comun.SeEstaCargandoInformacion(false);
        });
    },
    cambioAreaHistorialLaboral(datos) {
      this.datosLocales[0].valor.Id = parseInt(datos.target.value);
      this.datosLocales[0].valor.Nombre =
        datos.target.options[datos.target.selectedIndex].text;
      

      // Reinicia la selección(valor) del componente de Departamento
      this.datosLocales[1].valor.Id = -1;
      this.datosLocales[1].valor.Nombre = "";
    },
    cambioTipoDepartamentoLaboral(datos) {
      this.datosLocales[1].valor.Id = parseInt(datos.target.value);
      this.datosLocales[1].valor.Nombre =
        datos.target.options[datos.target.selectedIndex].text;
    },
    itemTypeExpr(obj) {
      return `employee${obj.ID}`;
    },
    showInfo(employee) {
      this.currentEmployee = employee;
      this.popupVisible = true;
    }
  }
};
</script>
<style scoped>
#diagram {
  height: 725px;
}

.dx-popup-content p {
  margin: 0 0 10px;
}
.custom-area {
        background-color: #7e7f74;
    }
    .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }
</style>



// WEBPACK FOOTER //
// src/components/SIAP/AdministracionPersonal/Organigrama.vue